import { useEffect, useMemo } from 'react';

import { composeSignInUrl } from '../../services/oauth/composeSignInUrl';

export const SignInRedirectPage = () => {
    const signInUrl = useMemo(() => composeSignInUrl(true), []);

    useEffect(() => {
        window.location.href = signInUrl;
    }, [signInUrl]);

    return null;
};
